import React from 'react';
import { Card, Tag, Progress } from 'antd';

const ScorecardBuckets = ({ scorecard, data }) => {
  const { bucket_1_3, bucket_4_6, bucket_7_10, errors, total } = data;
  const validTotal = total - errors;

  const buckets = [
    {
      name: '1-3',
      value: bucket_1_3,
      color: '#4CAF50',
      description: 'Low scores (good)',
      percentage: validTotal > 0 ? (bucket_1_3 / validTotal) * 100 : 0
    },
    {
      name: '4-6', 
      value: bucket_4_6,
      color: '#FF9800',
      description: 'Medium scores',
      percentage: validTotal > 0 ? (bucket_4_6 / validTotal) * 100 : 0
    },
    {
      name: '7-10',
      value: bucket_7_10,
      color: '#f44336',
      description: 'High scores (concerning)',
      percentage: validTotal > 0 ? (bucket_7_10 / validTotal) * 100 : 0
    }
  ];

  return (
    <Card 
      size="small"
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ color: '#ffffff', fontWeight: '600', fontSize: '14px' }}>
            Scorecard {scorecard} Distribution
          </span>
          <Tag 
            size="small" 
            color="blue"
            style={{ fontSize: '10px', fontWeight: '500' }}
          >
            Score Buckets
          </Tag>
        </div>
      }
      style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        marginBottom: '12px'
      }}
    >
      <div style={{ marginBottom: '12px' }}>
        <div style={{ 
          display: 'flex', 
          height: '40px', 
          borderRadius: '4px', 
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          {buckets.map((bucket, index) => (
            <div
              key={bucket.name}
              style={{
                backgroundColor: bucket.color,
                width: `${bucket.percentage}%`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '12px',
                fontWeight: 'bold',
                minWidth: bucket.percentage > 10 ? 'auto' : '0px',
                transition: 'all 0.3s ease'
              }}
              title={`${bucket.name}: ${bucket.value} apps (${bucket.percentage.toFixed(1)}%)`}
            >
              {bucket.percentage > 10 && (
                <span>{bucket.name}: {bucket.value}</span>
              )}
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {buckets.map((bucket) => (
          <div key={bucket.name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div 
                style={{ 
                  width: '12px', 
                  height: '12px', 
                  backgroundColor: bucket.color, 
                  borderRadius: '2px' 
                }}
              />
              <span style={{ color: '#e2e8f0', fontSize: '13px' }}>
                {bucket.name}: {bucket.description}
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ color: '#ffffff', fontWeight: '600', fontSize: '14px' }}>
                {bucket.value}
              </span>
              <span style={{ color: '#94a3b8', fontSize: '12px' }}>
                ({bucket.percentage.toFixed(1)}%)
              </span>
            </div>
          </div>
        ))}
      </div>

      {errors > 0 && (
        <div style={{ 
          marginTop: '12px', 
          padding: '8px 12px', 
          backgroundColor: 'rgba(239, 68, 68, 0.1)',
          border: '1px solid rgba(239, 68, 68, 0.3)',
          borderRadius: '4px'
        }}>
          <span style={{ color: '#fca5a5', fontSize: '12px' }}>
            ⚠️ {errors} apps with missing/invalid scores
          </span>
        </div>
      )}

      <div style={{ 
        marginTop: '12px', 
        paddingTop: '8px', 
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        fontSize: '12px',
        color: '#94a3b8'
      }}>
        Total evaluated: {validTotal} of {total} apps
      </div>
    </Card>
  );
};

export default ScorecardBuckets;